export const API_ENDPOINTS = {
  LOGIN: "/api/auth/signin",
  GOOGLE_LOGIN: "/api/auth/google",
  SIGNUP: "/api/auth/signup",
  MENTOR_SIGNUP: "/api/auth/mentor-signup",
  GET_MENTORS_LIST: "/api/mentorProfile/get/mentors",
  GET_ASSESSMENT_DATA: "/api/assessment/fetch-assessment",
  EMERGING_AI: "/api/ai-emerging-careers",
  MAINSTREAM_CAREERS: "/api/mainstream-careers/fetch-mainstream-careers",
  GET_AI_TOOLS: "/api/ai-tools",
  SAVE_FEEDBACK: "/api/feedback/save-feedback",
  SUBMIT_TICKET: "/api/tickets/submit",
  GET_COMPLAINS: "/api/tickets/all",
  GET_MENTOR_SLOTS: "/api/schedule/get-slots-mentor",
  GET_APPOINTMENT: "/api/schedule",
  BOOK_SLOT: "/api/schedule/book-slot",
  FETCH_TOTAL_USERS_MENTORS: "/api/admin/total-users-mentors",
  FETCH_USERS_BY_COUNTRY: "/api/admin/users-by-country",
  FILTER_COURESES: "/api/filter-courses/",
  MENTORING_APPLICATION: "/api/mentee-applications",
  UPSKILLING_PATHWAY: "/api/upskilling-pathway",
  UPSKILLING_PATHWAY_COUNTS: "/api/upskilling-pathway/counts",
  ADD_TO_LEARNING_PLAN: "/api/skill-gap-analysis/add-to-learning-plan",
  GET_LATEST_LEARNING_PLAN_ANALYSIS: "/api/skill-gap-analysis/latest-learning-plan",
  GET_SKILL_GAP_ANALYSES: "/api/skill-gap-analysis",
  GET_LATEST_SKILL_GAP_COUNT: "/api/skill-gap-analysis/latest-count",
  LOGOUT: "/api/auth/logout",
  FETCH_AI_LITERACY_REPORT: "/api/admin/ai-literacy-report",
  PROFICIENY_RACE_DATA: "/api/admin/proficiency-race-distribution",
  PROFICIENY_PERCENTAGE_DATA: "/api/admin/get-quiz-proficiency-percentage",
  MARK_WELCOME_SEEN: "/api/user/mark-welcome-seen",
  FETCH_JOB_AUTOMATION_DATA: "/api/admin/get-automation-risk-by-race",
  FETCH_JOB_AUTOMATION_PERCENTAGE_DATA:
    "/api/admin/get-automation-risk-percentage-by-race",
  FETCH_GENDER_REPORT: "/api/admin/get-gender-distribution",
  FETCH_PROFICIENCY_BY_GENDER: "/api/admin/get-quiz-proficiency-by-gender",
  CREATE_STRIPE_SESSION: "/api/stripe/create-stripe-session",
  SAVE_PENDING_USER: "/api/auth/save-pending-user",
  GET_PENDING_USER: "/api/stripe/session",
  GET_USER_BY_ID: "/api/auth/profile",
  ALL_JOBS: "/api/jobs/all-jobs",
  FETCH_USERS: "/api/user",
  CREATE_COURSE: "/api/virtualCourses/create",
  GET_COURSE: "/api/virtualCourses",
  REGISTER_COURSE: "/api/virtualCourses/register",
  COHORTS: "/api/cohorts",
  SEND_EMAIL_TO_MENTOR: "/api/admin/send-to-mentor",
  GET_COURSE_BY_ID: "/api/virtualCourses/user",
  GET_ALL_COURSE: "/api/virtualCourses",
  COURSE: "/api/virtualCourses/courses",
  CHORTS: "/api/cohorts",
  REGISTER_CHORTS: "/api/cohorts/register",
  USER_CHORTS: "/api/cohorts/user",
  GET_PROFILES: "/api/user/profiles",
  SEND_BULK_EMAILS: "/api/admin/send-bulk-emails",
  GET_USER: "/api/user/get-single-profile",
  GET_USERS_BY_QUATER: "/api/admin/users-by-quarter",
  GET_QUIZ_DATA: "/api/quiz/get-scores",
  GET_MENTOR_REVIEW: "/api/review/get",
  CREATE_MENTOR_REVIEW: "/api/review/create",
  GET_ALL_MENTORS_REVIEWS: "/api/review/allMentorReviews",
  UPDATE_REVIEW_APPROVAL: '/api/review/approval',
  UPDATE_GOOGLE_USER_PLAN: '/api/auth/update-google-user-plan',
  GET_AI_LITERACY_QUIZ: "/api/ai-literacy-quiz",
  CREATE_PROFILE: "/api/user/create-profile",
  UPDATE_PROFILE: "/api/user/update-profile",
  GET_SINGLE_PROFILE: "/api/user/get-single-profile",
  OCCUPATION_SKILLS: "/api/occupation-skills",
  EMERGING_SKILLS_BY_OCCUPATION: "/api/emerging/get-skills-by-occupation",
  MAINSTREAM_SKILLS_BY_OCCUPATION: "/api/mainstream-careers/get-skills-by-occupation",
  GET_ALL_MAINSTREAM_CAREERS: "/api/mainstream-careers/get-mainstream-careers-names",
  GET_ALL_EMERGING_CAREERS: "/api/emerging/get-emerging-careers-names",
  SAVE_CAREER_BOOKMARK: "/api/career-bookmarks/save",
  UNSAVE_CAREER_BOOKMARK: "/api/career-bookmarks/unsave",
  GET_CAREER_BOOKMARKS: "/api/career-bookmarks/user",
  GET_MENTOR_PROFILE: "/api/mentorProfile",
  GET_CONVERSATION_MESSAGES: "/api/conversation/messages",
  GET_CONVERSATIONS_LATEST_MESSAGE: "/api/conversation/conversations-latest-message",
  
  // Groups endpoints
  GET_ALL_GROUPS: "/api/groups",
  GET_USER_GROUPS: (userId) => `/api/groups/${userId}`,
  CREATE_GROUP: "/api/groups",
  UPDATE_GROUP: (groupId) => `/api/groups/${groupId}`,
  DELETE_GROUP: (groupId) => `/api/groups/${groupId}`,
  JOIN_GROUP: (groupId) => `/api/groups/${groupId}/join`,
  LEAVE_GROUP: (groupId) => `/api/groups/${groupId}/leave`,
  SEND_GROUP_MESSAGE: (groupId) => `/api/groups/${groupId}/messages`,
  GET_GROUP_MESSAGES: (groupId) => `/api/groups/${groupId}/messages`
};
